<template>
  <div class="overlay-survey">
    <i
      style="font-size: 200px"
      class="material-icons text-white me-2 cursor-pointer"
      >wifi_off</i
    >
  </div>
</template>

<script>
export default {
  name: "Connection",
};
</script>

<style>
.overlay-survey {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
</style>
